var _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharedPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.5H4.5V2.5H13.7929L19.5 8.20711V21.5Z",
    stroke: "#181818"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3725_38883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3725_38883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9748 17.9998C13.55 17.9998 13.1918 17.852 12.9002 17.5564C12.6086 17.2604 12.4628 16.9 12.4628 16.4752C12.4628 16.4168 12.4668 16.3584 12.4748 16.3C12.4832 16.2416 12.4958 16.1874 12.5126 16.1374L9.05 14.1376C8.9084 14.2624 8.75 14.3602 8.5748 14.431C8.4 14.5018 8.2168 14.5372 8.0252 14.5372C7.6 14.5372 7.2396 14.3894 6.944 14.0938C6.648 13.7978 6.5 13.4374 6.5 13.0126C6.5 12.5874 6.648 12.227 6.944 11.9314C7.2396 11.6354 7.6 11.4874 8.0252 11.4874C8.2168 11.4874 8.4 11.5208 8.5748 11.5876C8.75 11.654 8.9084 11.7498 9.05 11.875L12.5126 9.87522C12.4958 9.82522 12.4812 9.77102 12.4688 9.71262C12.4564 9.65422 12.4502 9.59582 12.4502 9.53742C12.4502 9.11262 12.598 8.75222 12.8936 8.45622C13.1896 8.16062 13.55 8.01282 13.9748 8.01282C14.4 8.01282 14.7604 8.16062 15.056 8.45622C15.352 8.75222 15.5 9.11262 15.5 9.53742C15.5 9.96262 15.352 10.323 15.056 10.6186C14.7604 10.9146 14.4 11.0626 13.9748 11.0626C13.7832 11.0626 13.602 11.0272 13.4312 10.9564C13.2604 10.8856 13.1042 10.7876 12.9626 10.6624L9.5 12.6628C9.5168 12.7124 9.5292 12.7686 9.5372 12.8314C9.5456 12.8938 9.5498 12.9542 9.5498 13.0126C9.5498 13.0626 9.5456 13.1188 9.5372 13.1812C9.5292 13.2436 9.5168 13.2998 9.5 13.3498L12.9626 15.3502C13.1042 15.225 13.2604 15.127 13.4312 15.0562C13.602 14.9854 13.7832 14.95 13.9748 14.95C14.4 14.95 14.7604 15.098 15.056 15.394C15.352 15.6896 15.5 16.05 15.5 16.4752C15.5 16.9 15.352 17.2604 15.056 17.5564C14.7604 17.852 14.4 17.9998 13.9748 17.9998Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedPage);
export default __webpack_public_path__ + "static/media/shared_page.20680dd0b46eb8f3bd91b6a70351ac83.svg";
export { ForwardRef as ReactComponent };